import { guardString } from "@msuite/utils/strings";
import type { IncomingInvoiceMyApprovalListItem } from "@msuite/utils/types";
import { formatInvoiceAmount, formatInvoiceDate } from "@/components/incoming-invoices";

/** Props Interface */
interface DashboardInvoiceApprovalItemProps {
	approval: IncomingInvoiceMyApprovalListItem;
}

/** One open approval: who billed, under which number, how much, and by when. */
export function DashboardInvoiceApprovalItem({ approval }: DashboardInvoiceApprovalItemProps) {
	/** Render */
	return (
		<>
			<div className="v-stack gap-0 items-start text-left min-w-0">
				<p className="truncate">{guardString(approval.issuerName)}</p>
				<p className="label">{guardString(approval.number)}</p>
			</div>
			<div className="flex-1" />
			<div className="v-stack gap-0 items-end shrink-0">
				<p className="tabular-nums">
					{formatInvoiceAmount(approval.grossAmount, approval.currency)}
				</p>
				<p className="label">{formatInvoiceDate(approval.dueDate)}</p>
			</div>
		</>
	);
}
